import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { Environment } from '../../../utils/Environment';
const SITE_KEY = Environment.googleRecaptchaSiteKey();

const ReCaptcha = forwardRef(function ReCaptcha(props, ref) {
  const recaptcha = useRef(null);
  useImperativeHandle(
    ref,
    () => ({
      getValue: () => recaptcha?.current?.getValue(), // eslint-disable-line no-unused-labels
    })
  );

  return <ReCAPTCHA ref={recaptcha} sitekey={SITE_KEY} />;
});

export default ReCaptcha;
